import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Calendar, Coins, Plus } from "lucide-react";
import AppLayout from "../components/AppLayout";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import { useAuth } from "../contexts/AuthContext";

// Mirrors the role gate on `/coach` so the button only appears to users
// who can actually use the create form on that page.
const CAN_CREATE_LESSON = new Set(["coach", "admin"]);

export default function Lessons() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [mine, setMine] = useState(false);
  useEffect(() => {
    api.get(`/lessons${mine ? "?mine=true" : ""}`).then((r) => setItems(r.data));
  }, [mine]);
  const canCreate = user && CAN_CREATE_LESSON.has(user.role);
  return (
    <AppLayout>
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-heading text-3xl sm:text-4xl font-black">{t("lessons")}</h1>
          <p className="text-zinc-400 mt-2">Book a coach and level up.</p>
        </div>
        <div className="flex items-center gap-2">
          {canCreate && (
            <div className="inline-flex rounded-xl bg-zinc-900 border border-zinc-800 p-1" data-testid="lessons-mine-toggle">
              <button data-testid="lessons-tab-all" onClick={() => setMine(false)} className={`px-3 py-2 rounded-lg text-sm ${!mine ? "bg-zinc-800 text-white" : "text-zinc-400 hover:text-white"}`}>All</button>
              <button data-testid="lessons-tab-mine" onClick={() => setMine(true)} className={`px-3 py-2 rounded-lg text-sm ${mine ? "bg-zinc-800 text-white" : "text-zinc-400 hover:text-white"}`}>My events</button>
            </div>
          )}
          {canCreate && (
            <Link to="/coach" data-testid="lessons-create" className="pp-btn-primary px-5 py-3 rounded-xl flex items-center gap-2">
              <Plus size={18} /> {t("create_lesson")}
            </Link>
          )}
        </div>
      </div>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="lessons-grid">
        {items.map((l) => (
          <Link key={l.id} to={`/lessons/${l.id}`} data-testid={`lesson-card-${l.id}`} className="pp-card p-6 block">
            <div className="flex items-center gap-2 text-xs text-[#00E676] uppercase tracking-wider"><GraduationCap size={14} /> {l.sport?.name}</div>
            <div className="font-heading text-xl font-bold mt-2">{l.title}</div>
            <div className="text-sm text-zinc-400 mt-2">with {l.coach?.first_name} {l.coach?.last_name}</div>
            <div className="mt-4 flex justify-between text-xs text-zinc-500">
              <span className="flex items-center gap-1"><Calendar size={12} /> {l.all_day ? new Date(l.start_time).toLocaleDateString() + " · All day" : new Date(l.start_time).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}</span>
              <span className="text-[#00E676] flex items-center gap-1"><Coins size={12} /> {l.price > 0 ? `${l.price} ${l.currency}` : t("free")}</span>
            </div>
          </Link>
        ))}
        {items.length === 0 && <div className="pp-card p-10 text-zinc-500 col-span-full text-center" data-testid="lessons-empty">{mine ? "You haven't created any lessons yet." : t("no_results")}</div>}
      </div>
    </AppLayout>
  );
}
